export default __webpack_public_path__ + "static/media/SuccessPayment.700f2ac0.svg";